export default __webpack_public_path__ + "static/media/Rishi-Laser.d28e3665.webp";